import theme from '@theme';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

import { Icon, IIconName } from '../icon';
import { Action, ActionInformation } from './types';
import { ActionState } from './constants';

interface CustomItemProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
  iconName: IIconName['iconName'];
}

interface ActionButtonProps {
  action: Action;
  setActionInformation: React.Dispatch<React.SetStateAction<ActionInformation>>;
}

const CustomItem = React.forwardRef<HTMLButtonElement, CustomItemProps>(
  ({ onClick, label, iconName }, ref) => (
    <CustomItemContainer
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <ItemIconContainer>
        <ItemCustomIcon iconName={iconName} />
      </ItemIconContainer>
      <FormatItemName>{label}</FormatItemName>
    </CustomItemContainer>
  )
);
CustomItem.displayName = 'CustomItem';

const ActionButton: React.FC<ActionButtonProps> = ({ action, setActionInformation }) => {
  const handleClick = async () => {
    setActionInformation({ state: ActionState.IN_PROGRESS });
    try {
      await action.callback();
      setActionInformation({ iconName: action.iconName, state: ActionState.COMPLETED });
    } catch {
      setActionInformation({ iconName: action.iconName, state: ActionState.FAILED });
    }
    setTimeout(() => {
      setActionInformation({ state: ActionState.NO_STATE });
    }, 2000);
  };
  return (
    <Dropdown.Item
      key={action.label}
      onClick={handleClick}
      as={CustomItem}
      label={action.label}
      iconName={action.iconName}
    />
  );
};

const CustomItemContainer = styled.button`
  display: grid;
  height: 1.6rem;
  grid-template-columns: 1fr 8.875rem;
  justify-items: start;
  column-gap: 0.375rem;
  width: 10rem;
  padding-right: 0.75rem;
  border-width: 0px;
  border-radius: 0.25rem;
  background-color: white;
  &:hover {
    background-color: ${theme.palette.blue[50]};
  }
`;

const ItemIconContainer = styled.div`
  width: 0.75rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ItemCustomIcon = styled(Icon)`
  width: 0.75rem;
  color: ${theme.palette.grey[400]};
  stroke-width: 3;
`;

const FormatItemName = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: 500;
  color: ${theme.palette.grey[800]};
  justify-content: center;
  align-items: center;
`;

export default ActionButton;
